/**
 * @desc 匹配规则DTO展示
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.fulfilment.WarehouseRulesDetailShowDto>, options?: any) {
  return updateResponse(
    http(URL + `/warehouseRules/rulesShow`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
